"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetPaymentGeneral = class FieldsetPaymentGeneral extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    isFieldEnabled(...args) {
        const name = args[0];
        return !this.config || !this.config.fields || this.config.fields[name] != false;
    }
    isFieldReadonly(...args) {
        const name = args[0];
        return this.isReadOnly || (this.config && this.config.fields && this.config.fields[name] == 'ro');
    }
    loadEmployees(...args) {
        return this.$fn
            .fetch('list_company_employees', { parameters: { company_id: this.payment.account.owner.id } })
            .then(items => items.sort((a, b) => a.name.localeCompare(b.name)));
    }
    payment;
    onPayment(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("payment");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    config;
    onConfig(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("config");
    }
    transactionTypes;
    onTransaction_types(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("transactionTypes");
    }
    autocalcAmount;
    onAutocalc_amount(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("autocalcAmount");
    }
    autocalcAmountInternal;
    async $$load_autocalcAmountInternal() {
        return this.autocalcAmount;
    }
    transactionTitles;
    async $$load_transactionTitles() {
        return this.$fn.fetch('get_tags', { parameters: { tag_type: 'payment' } })
            .then(data => _.map(data, p => p.name).sort((a, b) => a.localeCompare(b)));
    }
    paymentMethods;
    async $$load_paymentMethods() {
        return this.$fn.fetch('list_payment_method')
            .then(data => _
            .chain(data)
            .filter(p => this.payment.account.account_type !== 'cash_book' ? !p.cash : p.cash)
            .map(p => ({
            value: p.id,
            text: this.$fn.pgettext('PaymentMethod', p.name)
        }))
            .value());
    }
    employees;
    async $$load_employees() {
        return this.loadEmployees();
    }
    ux;
    b_8697745105058001_dataSource;
    dataMembers = ['autocalcAmountInternal', 'transactionTitles', 'paymentMethods', 'employees', 'ux', 'b_8697745105058001_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                autocalcAmountInternal: null,
                transactionTitles: null,
                paymentMethods: null,
                employees: null,
                ux: null,
                b_8697745105058001_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "partner",
                    },
                },
            },
        };
    }
    get isReadOnly() {
        if (this.loaded) {
            return this.payment.isReadonly;
        }
        return null;
    }
    get cashBookPayment() {
        if (this.loaded) {
            return this.payment.account && this.payment.account.account_type == 'cash_book';
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_4615685607825208_setData_7742_getActionArgs($event) {
        return {
            path: "payment.currency",
            value: $event.data.currency,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4615685607825208_script_7744_getActionArgs_value($event) {
        this.loadEmployees().then(items => this.setData('employees', items));
    }
    async act_4615685607825208_script_7744_getActionArgs($event) {
        return {
            value: () => this.act_4615685607825208_script_7744_getActionArgs_value($event),
        };
    }
    async act_4615685607825208_emit_7746_getActionArgs($event) {
        return {
            event: "accountChanged",
            value: $event.data,
        };
    }
    async evh_4615685607825208_input(event, scope) {
        return await this.actions.evh_4615685607825208_input.executeFromDOM(this, event, scope);
    }
    async act_47936024368137_emit_7748_getActionArgs($event) {
        return {
            event: "autocalcAmountChanged",
            value: this.autocalcAmountInternal,
        };
    }
    async evh_47936024368137_change(event, scope) {
        return await this.actions.evh_47936024368137_change.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7740 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7739 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7740,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7739],
        });
        const act_4615685607825208_setData_7742 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4615685607825208_setData_7742_getActionArgs,
            events: [],
        });
        const evh_4615685607825208_input_7741 = new core_1.actions.EventHandlerImpl({
            action: act_4615685607825208_setData_7742,
            event: "input",
            displayName: "setData",
        });
        const act_4615685607825208_script_7744 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4615685607825208_script_7744_getActionArgs,
            events: [],
        });
        const evh_4615685607825208_input_7743 = new core_1.actions.EventHandlerImpl({
            action: act_4615685607825208_script_7744,
            event: "input",
            displayName: "script",
        });
        const act_4615685607825208_emit_7746 = new core_1.actions.EmitAction({
            actionArgs: this.act_4615685607825208_emit_7746_getActionArgs,
            events: [],
        });
        const evh_4615685607825208_input_7745 = new core_1.actions.EventHandlerImpl({
            action: act_4615685607825208_emit_7746,
            event: "input",
            displayName: "emit",
        });
        const evh_4615685607825208_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4615685607825208_input_7741, evh_4615685607825208_input_7743, evh_4615685607825208_input_7745],
        });
        const act_47936024368137_emit_7748 = new core_1.actions.EmitAction({
            actionArgs: this.act_47936024368137_emit_7748_getActionArgs,
            events: [],
        });
        const evh_47936024368137_change_7747 = new core_1.actions.EventHandlerImpl({
            action: act_47936024368137_emit_7748,
            event: "change",
            displayName: "emit",
        });
        const evh_47936024368137_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_47936024368137_change_7747],
        });
        return {
            act_7315092382398562_reloadComponentData_7740,
            evh_7315092382398562_reload_7739,
            evh_7315092382398562_reload,
            act_4615685607825208_setData_7742,
            evh_4615685607825208_input_7741,
            act_4615685607825208_script_7744,
            evh_4615685607825208_input_7743,
            act_4615685607825208_emit_7746,
            evh_4615685607825208_input_7745,
            evh_4615685607825208_input,
            act_47936024368137_emit_7748,
            evh_47936024368137_change_7747,
            evh_47936024368137_change,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetPaymentGeneral.prototype, "payment", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('payment'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetPaymentGeneral.prototype, "onPayment", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetPaymentGeneral.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetPaymentGeneral.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetPaymentGeneral.prototype, "config", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('config'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetPaymentGeneral.prototype, "onConfig", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetPaymentGeneral.prototype, "transactionTypes", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('transactionTypes'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetPaymentGeneral.prototype, "onTransaction_types", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], FieldsetPaymentGeneral.prototype, "autocalcAmount", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('autocalcAmount'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetPaymentGeneral.prototype, "onAutocalc_amount", null);
FieldsetPaymentGeneral = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetPaymentGeneral);
exports.default = FieldsetPaymentGeneral;
vue_property_decorator_1.Vue.component("FieldsetPaymentGeneral", FieldsetPaymentGeneral);
